export var transitionDurationSeconds = 0.2;
//# sourceMappingURL=tabConstants.js.map